<script>
export default {
    name: "NoPlayerBanner"
};
</script>

<template>
    <img
        class="no-player-banner"
        :src="require('@/assets/img/no-player-banner.jpg')"
        alt="No Player Banner"
    />
</template>
